import axios from 'axios'

import { Consumption, ResponseConsumption } from '~/consumptions/model/consumption.model'
import { getToken } from '~/net'

export interface FetchConsumptionProps {
  subscriptionId: string
  provinceId: string
  brand: string
  sub: string
}

export class ConsumptionService {
  constructor(private apiGateway: string) {}

  fetchConsumptionService(
    fetchConsumptionServiceProps: FetchConsumptionProps,
  ): Promise<ResponseConsumption> {
    const { subscriptionId, provinceId, brand, sub } = fetchConsumptionServiceProps
    return getToken()
      .then((token) => {
        let authHeaders = {}

        if (token?.access_token !== 'NO_TOKEN_MOCK') {
          authHeaders = { authorization: `Bearer ${token.access_token}` }
        }

        return axios.get<Consumption>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/subscriptions/${subscriptionId}/consumption`,
          {
            params: {
              provinceId,
            },
            headers: {
              'x-sfid': sub,
              ...authHeaders,
            },
          },
        )
      })
      .then((resp) => ({
        subscriptionId: String(subscriptionId),
        consumption: resp.data,
      }))
  }
}
